module.exports = __webpack_public_path__ + "ca302f704ff95e6ee7aa494c6e1d4c94.jpg";